import Toastify from 'toastify-js';
const alertBadMove = (text) => {
    const defaults = {
        text,
        gravity: "top",
        position: "center",
        backgroundColor: '#f87d58',
        stopOnFocus: true,
    };
    Toastify(defaults).showToast();
};
export { alertBadMove };
